module.exports = __webpack_public_path__ + "img/lv.e342e711.svg";